import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { TokeetAIChargeLogResponse, TokeetAIChargeResponse } from './ai-charge.model'

@Injectable()
export class AIChargeService {
  constructor(private http: HttpClient) {}

  charges() {
    return this.http.get<TokeetAIChargeResponse[]>(`@api/subscription_prepaid/all`)
  }

  logs(subId: string) {
    return this.http.get<TokeetAIChargeLogResponse[]>(`@api/subscription_prepaid/logs/all?subscription_id=${subId}`)
  }
}
